import { AssignEnrollmentToAdviserInput } from '../../lib/types/models/enrollment/enrollment-input'
import { IdsInput } from '../../lib/types/utils'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function assignEnrollmentsToAdviser(data: AssignEnrollmentToAdviserInput & IdsInput) {
  const { id, ids } = data
  return restApiClient
    .url(
      encodeNestedObject<IdsInput>(
        constructApiUrl(API.enrollments.assignEnrollmentsToAdviser.url, null),
        { ids }
      )
    )
    .post<unknown, AssignEnrollmentToAdviserInput>({ id })
}
